export default __webpack_public_path__ + "static/media/process3.998dca54.webp";